import { Theme } from '@app/theme';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { HTMLAttributes } from 'react';

const useStyles = createUseStyles((theme: Theme) => ({
  checkboxItemContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'no-wrap',
    gap: theme.marginBase * 3,
    [theme.media.mobile]: {
      flexDirection: 'column',
    },
  },
}));

export const SetupCheckboxItemContainer = (
  props: HTMLAttributes<HTMLDivElement>,
) => {
  const classes = useStyles();
  return (
    <div
      {...props}
      className={classNames(classes.checkboxItemContainer, props.className)}
    />
  );
};
